import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tasks" }
const _hoisted_2 = {
  ref: "file_input",
  type: "file",
  class: "file",
  accept: "application/json, .txt"
}
const _hoisted_3 = {
  key: 0,
  class: "tg-data grid"
}
const _hoisted_4 = {
  key: 1,
  class: "topics grid"
}
const _hoisted_5 = {
  key: 2,
  class: "fixes grid"
}
const _hoisted_6 = {
  key: 3,
  class: "export grid"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _hoisted_2, null, 512 /* NEED_PATCH */),
    _createVNode(_component_Tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
      class: "tabs",
      tabs: $options.tabs
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    _createVNode(_component_SettingsFrame, null, {
      default: _withCtx(() => [
        ($data.active === 'tg-data')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode($setup["TasksRunner"], {
                class: "runner",
                "runner-id": "adm_import_tg_entities",
                caption: "Entities",
                runner: (tasks) => $options.runImport(tasks, 'entities')
              }, null, 8 /* PROPS */, ["runner"]),
              _createVNode($setup["TasksRunner"], {
                class: "runner",
                "runner-id": "adm_import_tg_data",
                caption: "Data",
                runner: (tasks) => $options.runImport(tasks, 'data')
              }, null, 8 /* PROPS */, ["runner"]),
              _createVNode($setup["TasksRunner"], {
                class: "runner",
                "runner-id": "adm_import_tg_edges",
                caption: "Edges",
                runner: (tasks) => $options.runImport(tasks, 'edges')
              }, null, 8 /* PROPS */, ["runner"]),
              _createVNode($setup["TasksRunner"], {
                class: "runner",
                "runner-id": "adm_clear_telegeography_pdfs",
                caption: "Clear PDFs",
                runner: (tasks) => $options.runClear(tasks, 'telegeography_pdfs')
              }, null, 8 /* PROPS */, ["runner"])
            ]))
          : ($data.active === 'topics')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode($setup["TasksRunner"], {
                  "runner-id": "adm_fix_topics_integrity",
                  caption: "Topics Integrity",
                  runner: (tasks) => $options.runFix(tasks, 'topics_integrity')
                }, null, 8 /* PROPS */, ["runner"]),
                _createVNode($setup["TasksRunner"], {
                  "runner-id": "adm_import_topics_replace",
                  caption: "Replace Topics",
                  runner: (tasks) => $options.runImport(tasks, 'topics_replace')
                }, null, 8 /* PROPS */, ["runner"])
              ]))
            : ($data.active === 'fixes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode($setup["TasksRunner"], {
                    "runner-id": "adm_fix_ingest",
                    caption: "Fix Ingest Meta",
                    runner: (tasks) => $options.runFix(tasks, 'ingest')
                  }, null, 8 /* PROPS */, ["runner"]),
                  _createVNode($setup["TasksRunner"], {
                    "runner-id": "adm_fix_ingest_removed",
                    caption: "Fix Ingest Removed",
                    runner: (tasks) => $options.runFix(tasks, 'ingest_removed')
                  }, null, 8 /* PROPS */, ["runner"]),
                  _createVNode($setup["TasksRunner"], {
                    "runner-id": "adm_fix_analysys_mason",
                    caption: "Fix Analysis Mason",
                    runner: (tasks) => $options.runFix(tasks, 'analysys_mason')
                  }, null, 8 /* PROPS */, ["runner"])
                ]))
              : ($data.active === 'export')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode($setup["TasksRunner"], {
                      "runner-id": "adm_export_users",
                      caption: "Export users",
                      runner: (tasks) => $options.runExport(tasks, 'users'),
                      "file-download": true
                    }, null, 8 /* PROPS */, ["runner"])
                  ]))
                : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}